import { useState, useEffect } from 'react'

const useImpact = widgets => {
  const [ impact, setImpact ] = useState({
    amount:           0,
    description:      '',
    currency_symbol:  '$',
  })

  const updateImpact = () =>
    fetch(`${widgets.origin}/widgets/impact/${widgets.impact}`, {
      headers: { Accept: 'application/json' }
    }).then(response => response.json()).then(setImpact)

  useEffect(() => {
    const interval = setInterval(updateImpact, 60000)
    updateImpact()
    return () => clearInterval(interval)
  }, [])

  return impact
}

export default useImpact
